"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateUUID = void 0;

var uuid_1 = require("uuid");

function generateUUID() {
  return uuid_1.v4().replace(/-/g, '');
}

exports.generateUUID = generateUUID;